import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["badge"]

  connect() {
    this.refresh()
  }

  refresh() {
    fetch("/notifications?format=json", {
      headers: { Accept: "application/json" }
    })
      .then(r => r.json())
      .then(data => {
        if (data.unread_count > 0) {
          this.#showBadge(data.unread_count)
        } else {
          this.#hideBadge()
        }
      })
      .catch(() => {})
  }

  #showBadge(count) {
    const badge = this.badgeTarget
    badge.textContent = count > 99 ? "99+" : count
    badge.classList.remove("hidden")
  }

  #hideBadge() {
    if (this.hasBadgeTarget) {
      this.badgeTarget.classList.add("hidden")
    }
  }
}
